var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper",class:{
    'wrapper--gray': _vm.isGray,
    'wrapper--white': _vm.isWhite,
    'wrapper--brown': _vm.isBrown,
  }},[_vm._l((_vm.filledBlocksToDisplay),function(block){return _c('div',{staticClass:"wrapper__filled"})}),_vm._v(" "),_vm._l((_vm.unfilledBlockToDisplay),function(block){return _c('div',{staticClass:"wrapper__unfilled"})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }